import React, { useState, useContext } from "react";
import "./feriado-modal.scss";
import { Formik } from "formik";
import Lottie from "react-lottie";
import MainContext from "../../../../Contexts/MainContext";
import { insertNewFeriado } from "../../../../Services/ApiCalls";
import { showToast } from "../../../../Functions";

const LOADING = require("../../../../Assets/animations/loading.json");
const SUCCESS = require("../../../../Assets/animations/success.json");
const ERROR = require("../../../../Assets/animations/error.json");

const AddSelectedFeriado: React.FC = () => {
    const { token, sethasCloseEditModal, removehasCloseEditModal, setaddModalOpen } = useContext(MainContext);

    const [isSubmiting, setIsSubmiting] = useState(false);
    const [updateSuccess, setupdateSuccess] = useState(false);
    const [updateError, setUpdateError] = useState(false);

    return (
        <div className="selected__wrapper feriado-modal-wrapper">
            {!isSubmiting ? (
                <Formik
                    initialValues={{ nome: "", data: "", tipo: "Nacional", aliquota: 100, recorrente: false }}
                    onSubmit={async (values) => {
                        setIsSubmiting(true);
                        const payload = {
                            nome: values.nome,
                            data: values.data, // YYYY-MM-DD
                            tipo: values.tipo,
                            aliquota: Number(values.aliquota),
                            recorrente: values.recorrente
                        };

                        const responseSubmit = await insertNewFeriado(token, payload);

                        if (responseSubmit?.statusType === "SUCCESS") {
                            setupdateSuccess(true);
                            showToast("SUCCESS", "Feriado cadastrado com sucesso!", {});
                            window.setTimeout(() => {
                                sethasCloseEditModal(true);
                                removehasCloseEditModal("closedModal");
                                setaddModalOpen(false);
                            }, 2000);
                        } else {
                            setUpdateError(true);
                            showToast("ERROR", "Erro ao cadastrar feriado", {});
                            setIsSubmiting(false);
                        }
                    }}
                    validate={(values) => {
                        const errors: any = {};
                        if (!values.nome) errors.nome = "Insira o nome do feriado";
                        if (!values.data) errors.data = "Selecione a data";
                        if (values.aliquota === undefined || values.aliquota === null || values.aliquota < 0) errors.aliquota = "Alíquota inválida";
                        return errors;
                    }}
                >
                    {({ values, handleChange, handleSubmit, errors }) => (
                        <form onSubmit={handleSubmit} className="feriado-form">
                            <div className="feriado-modal-header">
                                <h2>Novo Feriado</h2>
                                <p>Cadastre um novo feriado para aplicar regras automáticas de acréscimo.</p>
                            </div>

                            <div className="form-grid-row">
                                <div className="form-cell grow-2">
                                    <label>Nome do Feriado</label>
                                    <input 
                                        type="text" 
                                        value={values.nome}
                                        className={errors.nome ? "hasError" : ""}
                                        onChange={handleChange("nome")}
                                        placeholder="Ex: Natal, Proclamação da República" 
                                    />
                                    {errors.nome && <div className="form__error"><p>{errors.nome}</p></div>}
                                </div>
                                <div className="form-cell grow-1">
                                    <label>Data</label>
                                    <input 
                                        type="date" 
                                        value={values.data}
                                        className={errors.data ? "hasError" : ""}
                                        onChange={handleChange("data")}
                                    />
                                    {errors.data && <div className="form__error"><p>{errors.data}</p></div>}
                                </div>
                            </div>

                            <div className="form-grid-row">
                                <div className="form-cell grow-1">
                                    <label>Tipo</label>
                                    <select value={values.tipo} onChange={handleChange("tipo")}>
                                        <option value="Nacional">Nacional</option>
                                        <option value="Municipal">Municipal</option>
                                        <option value="Facultativo">Facultativo</option>
                                    </select>
                                </div>
                                <div className="form-cell grow-1">
                                    <label>Alíquota de Acréscimo (%)</label>
                                    <div className="aliquota-input-wrapper">
                                        <input 
                                            type="number" 
                                            value={values.aliquota}
                                            className={errors.aliquota ? "hasError" : ""}
                                            onChange={handleChange("aliquota")}
                                            min="0"
                                            max="300"
                                        />
                                        <span className="percent-sign">%</span>
                                    </div>
                                    {errors.aliquota && <div className="form__error"><p>{errors.aliquota}</p></div>}
                                </div>
                            </div>

                            <div className="form-grid-row">
                                <div className="form-cell grow-1">
                                    <label>Feriado Recorrente (Anual)?</label>
                                    <div style={{ display: 'flex', alignItems: 'center', height: '40px' }}>
                                        <input 
                                            type="checkbox" 
                                            checked={values.recorrente}
                                            onChange={handleChange("recorrente")}
                                            style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                        />
                                        <span style={{ marginLeft: '10px', fontSize: '14px', color: '#666' }}>Sim, repete todo ano</span>
                                    </div>
                                </div>
                            </div>

                            <div className="feriado-modal-footer">
                                <button type="button" className="btn-cancel" onClick={() => setaddModalOpen(false)}>Cancelar</button>
                                <button type="submit" className="btn-save" disabled={!!errors.nome || !!errors.data}>Cadastrar Feriado</button>
                            </div>
                        </form>
                    )}
                </Formik>
            ) : (
                <div className="feriado-submitting">
                    <Lottie options={{ loop: !updateSuccess, animationData: !updateSuccess && !updateError ? LOADING : updateSuccess ? SUCCESS : ERROR }} height={120} width={120} />
                    <p>{updateSuccess ? "Feriado cadastrado!" : updateError ? "Ops, algo deu errado" : "Salvando..."}</p>
                </div>
            )}
        </div>
    );
};

export default AddSelectedFeriado;
